<template>
    <div class="layer">
        <div class="wrap">
            <HeaderLayout></HeaderLayout>
            <div class="content">
                <p class="page_title"> 스트레스 케어 </p>
                <div class="board_wrap">
                    <div class="board_search_box">
                        <input type="text" name="" id="" v-model="list.search" @keydown.enter="searchContents">
                        <button type="button" @click="searchContents">검색</button>
                    </div>
                    <div class="board_category">
                        <button @click="selectTag(0)" :class="state.selectCategoryIdx === -1 ? 'active' : ''">
                            전체
                        </button>
                        <button :class="state.selectCategoryIdx === index ? 'active' : ''"
                            v-for="(tag, index) in list.category" @click="selectTag(index + 1)">
                            {{ tag.name }}
                        </button>
                    </div>
                    <DataGrid :list="list.data" :columns="list.fields" :totalLength="list.length" :isShowPageBtn="true"
                        :perPage="list.size" :current-page="list.currentPage" @onRowClick="moveDetail"
                        @onPaging="handlePageChange" @onNextPage="handlePageChange" @onPrevPage="handlePageChange"
                        @onFirstPage="handlePageChange" @onLastPage="handlePageChange">
                    </DataGrid>
                </div>
            </div>
        </div>
    </div>
    <GnbLayout></GnbLayout>
    <ModalComponent :show="state.isModalOpen" :content="state.modalContent" @close="modalClose"> </ModalComponent>
</template>
<script lang="ts">
import {
    reactive,
    onMounted,
    apiService,
    res,
    router,
    DataGrid,
    HeaderLayout,
    GnbLayout,
    ModalComponent,
    globalStore,
} from "@/BaseComponent";

export default {
    components: {
        HeaderLayout,
        GnbLayout,
        DataGrid,
        ModalComponent,
    },
    setup() {
        const global = globalStore();
        const state = reactive({
            selectCategoryIdx: 0 as number,
            modalContent: "" as string,
            isModalOpen: false as boolean,
        });
        const list = reactive({
            categoryIdx: 0 as number,
            data: [] as any[],
            selectCategory: "" as any,
            category: [] as any,
            search: "" as string | null,
            size: 8 as number,
            length: 1 as number,
            currentPage: 1 as number,
            totlapage: 1 as number,
            selected: [] as any[],
            fields: [
                {
                    key: "fileLocation",
                    label: "이미지",
                    clickable: true,
                    class: "title_img",
                    render: (row: any) => {
                        return (
                            `<a><img src="${row.thumbnail}" style="width: 100px; height: 70px;">` +
                            (row.isImportant === 1 ? '<span class="color_r">[중요]</span> ' : "") +
                            row.title +
                            "</a>"
                        );
                    },
                },
            ],
        });

        const handlePageChange = (page: number) => {
            list.currentPage = page;
            getList();
        };

        onMounted(() => {
            if (history.state != null || history.state != undefined) {
                list.categoryIdx = history.state.categoryIdx;
                state.selectCategoryIdx = history.state.categoryIdx - 1;
            }
            getCategory();
            getList();
        });

        const selectTag = (categoryIdx: number) => {
            history.state.categoryIdx = categoryIdx;
            state.selectCategoryIdx = categoryIdx - 1;
            list.categoryIdx = categoryIdx;
            list.currentPage = 1;
            list.search = null;
            getList();
        };

        const getCategory = async () => {
            let res: res = await apiService.stressCare.getCategory();
            if (res.returnCode === 0) {
                list.category = res.list;
            } else {
                state.modalContent = res.description;
                state.isModalOpen = true;
            }
        };

        const getList = async () => {
            let res = await apiService.stressCare.getList(list.currentPage, list.categoryIdx, list.size, list.search);
            if (res.returnCode === 0) {
                list.length = res.data.recordsTotal;
                list.totlapage = res.data.totalPages;
                list.data = res.data.data;
            } else {
                state.modalContent = res.description;
                state.isModalOpen = true;
            }
        };

        const moveDetail = (index: number) => {
            router.push({ path: `/stressCare/detail/${index}` });
        };

        const searchContents = () => {
            list.currentPage = 1;
            getList();
        };

        const modalClose = () => {
            state.isModalOpen = false;
        };

        return {
            state,
            list,
            handlePageChange,
            selectTag,
            moveDetail,
            searchContents,
            modalClose,
        };
    },
};
</script>
